export default __webpack_public_path__ + "921a3fee074f36ad46187e3ea6907616.svg";